import React, { useState, useEffect } from 'react'
import {
  Panel,
  Message,
  Table,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  IconButton,
  Icon,
  ButtonGroup,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import { isValidators, requiredFiled, getMaxLengthData } from '../../../utils/ValidatorUtils'
import ProjectTrackingNoteForm from './ProjectTrackingNoteForm'
import ProjectInfoWidget from './ProjectInfoWidget'
import AttachFilesForm from '../../attachfiles/AttachFilesForm'
import {
  saveTrackingNote,
  editTrackingNote,
  deleteTrackingNote,
  saveAttachments,
  getAttachments,
  getDownload,
  updateAttachments,
  deleteAttachments,
} from '../../../redux/actions/adminManageProjectClosedLate'
import ProjectTrackingNoteAttachFilesWidget from './ProjectTrackingNoteAttachFilesWidget'
import moment from 'moment'
import { getTrackingNote } from '../../../redux/actions/adminManageProjectClosedLate'
import ConfirmWidget from '../../confirm/ConfirmWidget'

export default function ProjectTrackingNoteWidget(props) {
  const { Column, HeaderCell, Cell } = Table
  const { onClose, rowData, onSaveSuccess } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [errorMsg, setErrorMsg] = useState()
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [editData, setEditData] = useState()
  const [attachFiles, setAttachFiles] = useState()
  const [schemaNoteForm, setSchemaNoteForm] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [rowDelayId, setRowDelayId] = useState()
  const [deleteObj, setDeleteObj] = useState({})
  const [isShowConfirm, setIsShowConfirm] = useState(false)

  useEffect(() => {
    setFormSchema(props.schema)
    setAttachFiles(props.schema)
    setSchemaNoteForm(props.schema.form)
  }, [props.schema])

  const onSubmit = (data) => {
    console.log('onSubmit', data)

    const formData = new FormData()

    if (data?.file?.length > 0 && data.file != undefined) {
      data.file?.forEach((element) => {
        formData.append('Files', element.blobFile)
      })
    } else {
      console.log('file null')
      formData.append('Files', null)
    }

    formData.append('ProjectVersionId', rowData.projectId || '')
    formData.append('Note', data.inputNote || '')
    formData.append('Date', moment(data.inputDate).format('YYYY/MM/DD') || '')
    formData.append('NotifyStatus', data.notiStatus || '')
    // formData.append('Files', null)

    handleSaveTrackingNote(formData)
  }

  const onEdit = (data) => {
    console.log('onEdit ', data)
    const formData = new FormData()

    if (data?.file?.length > 0 && data.file != undefined) {
      data.file?.forEach((element) => {
        formData.append('Files', element.blobFile)
      })
    } else {
      formData.append('Files', null)
    }

    formData.append('ProjectVersionId', rowData.projectId || '')
    formData.append('Note', data.inputNote || '')
    formData.append('Date', moment(data.inputDate).format('YYYY/MM/DD') || '')
    formData.append('NotifyStatus', data.notiStatus || '')

    handleUpdateTrackingNote(rowData.projectId, rowDelayId, formData)
  }

  const handleSaveTrackingNote = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()

    try {
      console.log('handleSaveTrackingNote save')
      const response = await saveTrackingNote(request)

      // console.log('res ', response)
      if (response.success) {
        setErrorMsg({ type: 'success', description: 'บันทึกสำเร็จ' })
        onSaveSuccess(rowData.projectId)
      } else {
        setErrorMsg({ type: 'error', description: response.errorMessage })
      }
      setIsEdit(false)
      setRowDelayId()
      setTimeout(() => {
        setErrorMsg(null)
      }, 5000)
    } catch (error) {
      console.error('try catch error ', error)
      setIsError(true)
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleUpdateTrackingNote = async (projectId, rowDelayId, request) => {
    startLoading()
    setIsLoading(true)
    setIsError()

    try {
      console.log('handleUpdateTrackingNote update ', projectId, rowDelayId, request)
      const response = await editTrackingNote(projectId, rowDelayId, request)

      console.log('res ', response)
      if (response.success) {
        setErrorMsg({ type: 'success', description: 'บันทึกสำเร็จ' })
        onSaveSuccess(rowData.projectId)
      } else {
        setErrorMsg({
          type: 'error',
          description:
            response.errorMessage ||
            'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ',
        })
      }

      setRowDelayId()
      setIsEdit(false)
      setTimeout(() => setErrorMsg(null), 5000)
    } catch (error) {
      console.error('try catch error ', error)
      setIsError(true)
    }

    setIsLoading(false)
    doneLoading()
  }

  const onCancel = async () => {
    console.log('on cancel 2')
    onClose()
    // setFormSchema(formSchema)
  }

  const handleEditRowData = (rowData) => {
    console.log('handleEditRowData ', rowData)
    handleGetTrackingNote(rowData.projectVersionId, rowData.id)
  }

  const handleGetTrackingNote = async (projectVersionId, delayId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getTrackingNote(projectVersionId, delayId)
      if (response.success) {
        // setFormSchema(response.model)
        setIsEdit(true)
        setRowDelayId(delayId)
        setSchemaNoteForm(response.model.form)
        setAttachFiles(response.model.attachFiles)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleDeleteRow = async () => {
    console.log('handleDeleteRow ', deleteObj)

    startLoading()
    setIsLoading(true)
    try {
      const response = await deleteTrackingNote(deleteObj.projectVersionId, deleteObj.id)
      console.log('response ', response)
      if (response == 200) {
        onSaveSuccess(rowData.projectId)
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.statusText || 'ลบไม่สำเร็จ',
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    console.log('onPreview ', fileObj)
    startLoading()
    var file = await getDownload(rowData.projectId, fileObj.id)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    console.log('onDownload', fileObj)

    startLoading()
    var file = await getDownload(rowData.projectId, fileObj.id)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onUpdate = (file, newName) => {
    console.log('onUpdate file', file, 'newName: ', newName)

    file['projectVersionId'] = rowData.projectId
    file['userId'] = 111
    file.label = newName
    file.lable = newName
    file.fileId = file.id

    console.log('file', file)
    handleUpdate(file)
  }

  const handleUpdate = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsEditErr()
    try {
      console.log('update')
      const response = await updateAttachments(rowData.projectId, request)

      if (response) {
        setIsEditErr(false)

        setAttachFiles(response)
        // onSaveSuccess(rowData.projectId)
      } else {
        setIsEditErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsEditErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDelete = (index) => {
    // console.log('handleDelete', index)
    // console.log('attachFiles ', attachFiles)
    let datas = [...attachFiles.value]
    handleDelete(datas[index])
  }

  const handleDelete = async (schema) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError()
    try {
      console.log('call delete.')
      const status = await deleteAttachments(rowData.projectId, schema.id)
      if (status === 200) {
        console.log('call get.')
        const _schema = await getAttachments(rowData.projectId)
        console.log('result', _schema)
        setAttachFiles(_schema)
        setIsDeleteError(false)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        header={formSchema.header}
        shaded
        bordered
        collapsible
        defaultExpanded
        style={{ marginTop: 20, marginBottom: 20 }}
      >
        {rowData && (
          <>
            <ProjectInfoWidget schema={rowData} shaded={false} />
          </>
        )}

        {formSchema?.form && (
          <>
            <ProjectTrackingNoteForm
              schema={formSchema?.form}
              schemaAttachFiles={attachFiles}
              schemaNoteForm={schemaNoteForm}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              // handelPreview={onSubmit}
              onPreview={onPreview}
              onDownload={onDownload}
              onUpdate={onUpdate}
              onDelete={onDelete}
              isEditErr={isEditErr}
              isUploadErr={isUploadErr}
              isDeleteError={isDeleteError}
              loading={isLoading}
              isEdit={isEdit}
            />
          </>
        )}

        <br />

        {errorMsg && (
          <Message
            showIcon
            type={errorMsg.type}
            description={errorMsg.description}
            style={{ marginBottom: 20 }}
          />
        )}

        {isEdit ? (
          <>
            <IconButton
              appearance="ghost"
              icon={<Icon className="bt-gost-icon-radius" icon={'edit'} />}
              style={{ marginRight: 5 }}
              onClick={handleSubmit((e) => onEdit(e))}
            >
              {`${formSchema.form.buttonText.saveButtonName}แก้ไข`}
            </IconButton>
          </>
        ) : (
          <>
            <IconButton
              appearance="ghost"
              icon={<Icon className="bt-gost-icon-radius" icon={'save'} />}
              style={{ marginRight: 5 }}
              onClick={handleSubmit((e) => onSubmit(e))}
            >
              {formSchema.form.buttonText.saveButtonName}
            </IconButton>
          </>
        )}

        <IconButton
          appearance="ghost"
          className="rs-btn-ghost-cancel"
          icon={<Icon className="bt-gost-icon-radius-cancel" icon="close" />}
          style={{ marginRight: 5 }}
          onClick={(_) => {
            setIsEdit(false)
            onSaveSuccess(rowData.projectId)
          }}
        >
          {formSchema.form.buttonText.cancelButtonName}
          {isEdit ? 'แก้ไข' : `${formSchema.form.buttonText.saveButtonName}`}
        </IconButton>

        <IconButton
          appearance="ghost"
          className="rs-btn-ghost-cancel"
          icon={<Icon className="bt-gost-icon-radius-cancel" icon="close" />}
          style={{ marginRight: 5 }}
          onClick={(_) => {
            onCancel()
          }}
        >
          ยกเลิก{`${formSchema.header}`}
        </IconButton>
        {/* <ButtonPanelWidget
          isEdit={true}
          isError={isError}
          buttonText={formSchema.form.buttonText}
          onSave={handleSubmit(onSubmit)}
          onCancel={onCancel}
          // onCancel={(el) => {
          //   // setDataTable(null)
          //   setOnClear(true)
          //   // setIsError(false)
          //   // location.reload()
          // }}
        /> */}

        <br />

        {/* <ProjectTrackingNoteAttachFilesWidget
          schema={formSchema.attachFiles}
          projectDelayId={formSchema.form.projectDelayId}
          rowData={rowData}
        />

        <br /> */}

        <Table
          wordWrap
          height={400}
          // loading={loading}
          data={formSchema.values}
          style={{ marginTop: '20px' }}
        >
          <Column width={70} align="center" fixed>
            <HeaderCell>ครั้งที่</HeaderCell>
            <Cell dataKey="numberOfSequence" />
          </Column>

          <Column minWidth={100}>
            <HeaderCell>วันที่</HeaderCell>
            {/* <Cell dataKey="date" /> */}
            <Cell>
              {(rowData) => {
                return moment(rowData.entryDate).format('DD/MM/YYYY') || ''
              }}
            </Cell>
          </Column>

          <Column minWidth={350} flexGrow={1}>
            <HeaderCell>รายละเอียดการติดตาม</HeaderCell>
            <Cell dataKey="description" />
          </Column>

          {formSchema.form.notiStatus && (
            <Column width={220}>
              <HeaderCell>การแจ้งเตือน</HeaderCell>
              {/* <Cell dataKey="type" /> */}
              <Cell>
                {(rowData) => {
                  let str = ''
                  switch (rowData.notifyStatus) {
                    case 1:
                      str = 'โทรศัพท์ติดตาม'
                      break
                    case 2:
                      str = 'ออกหนังสือแจ้งเตือน'
                      break
                    case 3:
                      str = 'ออกหนังสือตามงาน'
                      break
                    default:
                      break
                  }
                  return str
                }}
              </Cell>
            </Column>
          )}

          <Column width={200} align="center" fixed="right">
            <HeaderCell>จัดการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-edit"
                        icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                        onClick={() => {
                          handleEditRowData(rowData)
                        }}
                      >
                        แก้ไข
                      </IconButton>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash" className="bt-gost-icon-none-radius-cancel" />}
                        onClick={() => (setDeleteObj(rowData), setIsShowConfirm(true))}
                      >
                        ลบ
                      </IconButton>
                    </ButtonGroup>
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>

        <ConfirmWidget
          title={`ยืนยันการลบรายการ`}
          show={isShowConfirm}
          detail={`ยืนยันการลบ`}
          onCancle={() => {
            setIsShowConfirm(false)
            setDeleteObj({})
          }}
          onConfirm={() => {
            handleDeleteRow()
            // let total = schema.searchResult.reviewerItems.length
            // let newPage = Math.ceil(total / displayLength)
            // if (newPage > 0 && newPage < page) {
            //   setPage(newPage)
            // }
            setIsShowConfirm(false)
          }}
        />
      </Panel>
    </>
  )
}
